/**
 * Zero indexed week day mapping https://day.js.org/docs/en/get-set/day
 */
export const DayOfWeek = Object.freeze({
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
})

export const Weekdays = Object.entries(DayOfWeek).map(([name, value]) => ({
  key: name.toLowerCase(),
  letter: name.charAt(0),
  value,
}))
